import { Search } from "@/src/svg/Search";
import { Menu } from "@/src/svg/Menu";
import { CloseBtn } from "@/src/svg/CloseBtn";

export const headerNavLinks = [
  {
    id: "about",
    text: "ABOUT US",
    link: "/about",
    submenu: [
      {
        id: "university",
        text: "ABOUT UNIVERSITY",
        link: "/about/university",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "welcome",
        text: "WELCOME WORDS",
        link: "/about/welcome",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "structure",
        text: "STRUCTURE UNIVERSITY",
        link: "/about/structure",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "accreditation",
        text: "LICENSING AND ACCREDITATION",
        link: "/about/licensing",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "process",
        text: "ACADEMIC PROCESS",
        link: "/about/academic-process",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "reasons",
        text: "REASON TO CHOOSE US",
        link: "/about/reasons",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "news",
        text: "NEWS",
        link: "/about/news",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
    ],
  },
  {
    id: "about-malta",
    text: "About Malta",
    link: "/about-malta",
    submenu: [
      {
        id: "accreditation",
        text: "LICENSING AND ACCREDITATION",
        link: "/about/licensing",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "process",
        text: "ACADEMIC PROCESS",
        link: "/about/academic-process",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "reasons",
        text: "REASON TO CHOOSE US",
        link: "/about/reasons",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
      {
        id: "news",
        text: "NEWS",
        link: "/about/news",
        description:
          "leading regional institution offering a wide range of academic programs and disciplines.",
      },
    ],
  },
  { id: 3, text: "Programms", link: "" },
  { id: 4, text: "Admissions", link: "" },
  { id: 5, text: "Education", link: "" },
  { id: 6, text: "Facilities", link: "" },
  { id: 7, text: "International Activity", link: "" },
  { id: 8, text: "FAQ", link: "" },
];

export const headerTabsMenu = [
  {
    id: "search",
    icon: Search,
    activeIcon: CloseBtn,
    text: "Search",
  },
  {
    id: "menu",
    icon: Menu,
    activeIcon: CloseBtn,
    text: "Menu",
  },
];
